import { Icon } from '@hapvida/hapvida-core-components';

import type { IAppRoute } from 'routes/types';
import { FEATURE_TOGGLE } from '@constants';

import { BeneficiaryListRouter } from './pages/BeneficiaryList/router';
import { LetterOfStayRouter } from './pages/LetterOfStay/router';
import {
  AuthenticateCertificateRouter,
  BeneficiariesRouter,
  OnlineCardRouter,
  SuspendedBeneficiaryRouter,
} from './redirects/router';
import { BeneficiaryServicesRouter } from './pages/BeneficiaryServices/router';

export const BeneficiaryGroupRouter: IAppRoute = {
  Page: BeneficiaryListRouter.Page,
  path: BeneficiaryListRouter.path,
  name: 'Beneficiários',
  isPrivate: true,
  Icon: <Icon name="actions-b2b-groups" />,
  subRoutes: [
    FEATURE_TOGGLE.BENEFICIARIES_V3
      ? BeneficiaryListRouter
      : BeneficiariesRouter,
    BeneficiaryServicesRouter,
    SuspendedBeneficiaryRouter,
    LetterOfStayRouter,
    OnlineCardRouter,
    AuthenticateCertificateRouter,
  ],
};
